import React, { useState, useEffect, useRef } from 'react';

//Animation
import { useAutoAnimate } from '@formkit/auto-animate/react'

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Skeleton
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

//ICONS
import { BsCheck2Circle } from "react-icons/bs";

//APIS
import { systemGet, systemUpdate } from '../../../apis/system'

const SistemAyarlari = () => {

    const [animationParent] = useAutoAnimate()
    const [loading, setLoading] = useState(false) // Skleton için kullanılacak


    //REFS
    const smsCheckRef = useRef()
    const epostaCheckRef = useRef()
    const epostaInputRef = useRef()
    const passwordInputRef = useRef()

    //STATES
    const [smsCheck, setSmsCheck] = useState(false)
    const [epostaCheck, setEpostaCheck] = useState(false)
    const [epostaInput, setEpostaInput] = useState("")
    const [passwordInput, setPasswordInput] = useState("")

    //HANDLE FUNCTIONS

    const handleFormControl = async ()=>{

        let data = {
            systemMailAdress : epostaInput,
            systemMaidPassword : passwordInput,
            sms: smsCheck,
            mail : epostaCheck
        }

        let result = await systemUpdate(data)
        if (result.status === 200){
            return toast.success("Kayıt güncellendi", {
                position: toast.POSITION.TOP_LEFT
            });
        }else{
            return toast.error(result.response.data.message, {
                position: toast.POSITION.TOP_LEFT
            });
        }

    }

    //API FUNCTIONS

    const getSystemLIST = async () =>{
        setLoading(true)
        let result = await systemGet()
        //console.log(result.data)
        if(result.status === 200){
            //setSystemLIST(result.data)
            setSmsCheck(result.data[0].SMS)
            setEpostaCheck(result.data[0].Mail)
            setEpostaInput(result.data[0].systemMailAdress)
            setPasswordInput(result.data[0].systemMaidPassword)
            setLoading(false)
        }
    }

    useEffect(() => {
        
        getSystemLIST()
    }, []);


    return (
        <>
            <ToastContainer />
            <main className='text-slate-500 text-sm transition-all'>
                <div className="py-5">
                    <div className="w-full px-4 sm:px-6 md:px-8">
                        <div className='container mx-auto'>
                            <h1 className='page-title leading-6 font-normal text-lg mb-6 text-slate-500'>Sistem Ayarları</h1>
                        </div>
                        <div className='container mx-auto space-y-4'>
                            <div className='kapsama relative w-full flex flex-col lg:flex-row gap-4'>


                                <div className='sag w-full max-w-3xl'>
                                    <div className='bg-white rounded-lg p-4 min-h-0'>
                                        <div ref={animationParent}>
                                            {
                                                loading ? <Skeleton baseColor="#e2e8f0" width="100%" count={3} height={20} /> : (
                                                    <>
                                                        <h1 className=' text-slate-700'>Geri bildirimler için hangi iletişim aracı kullanılsın?</h1>
                                                        <div className='flex flex-col items-start gap-4 mb-6'>
                                                            <div className='w-full mt-2 flex gap-x-8'>
                                                                <div className="relative flex items-start">
                                                                    <div className="flex h-6 items-center">
                                                                        <input
                                                                            checked={smsCheck}
                                                                            ref={smsCheckRef}
                                                                            onChange={()=>{setSmsCheck((state) => !state)}}
                                                                            id="SMS"
                                                                            type="checkbox"
                                                                            className="h-4 w-4 rounded"
                                                                        />
                                                                    </div>
                                                                    <div className="ml-3 text-sm leading-6">
                                                                        <label htmlFor="SMS" className="font-medium text-slate-500">
                                                                            SMS
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className="relative flex items-start">
                                                                    <div className="flex h-6 items-center">
                                                                        <input
                                                                            ref={epostaCheckRef}
                                                                            checked={epostaCheck}
                                                                            onChange={()=>{setEpostaCheck((state) => !state)}}
                                                                            id="EPOSTA"
                                                                            type="checkbox"
                                                                            className="h-4 w-4 rounded"
                                                                        />
                                                                    </div>
                                                                    <div className="ml-3 text-sm leading-6">
                                                                        <label htmlFor="comments" className="font-medium text-slate-500">
                                                                            E-POSTA
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>                                                        
                                                        <h1 className=' text-slate-700'>E-Posta bilgilerini giriniz</h1>
                                                        <div className='flex flex-col items-start gap-2 mb-6 mt-2'>
                                                            <div className='w-full'>
                                                                <label>E-Posta</label>
                                                                <input 
                                                                    ref={epostaInputRef} 
                                                                    value={epostaInput} 
                                                                    onChange={(e)=>setEpostaInput(e.target.value)}
                                                                    type='text' placeholder='@odu.edu.tr' className='sd-form-input' />
                                                            </div>
                                                            <div className='w-full'>
                                                                <label>Şifre</label>
                                                                <input 
                                                                    ref={passwordInputRef} 
                                                                    value={passwordInput} 
                                                                    onChange={(e)=>setPasswordInput(e.target.value)}
                                                                    type='password' placeholder='***' className='sd-form-input' />
                                                            </div>
                                                        </div>
                                                        <div className='w-full flex gap-x-4 mt-6'>
                                                            <div className='text-right'>
                                                                <button onClick={()=>handleFormControl()} className='w-full text-xs h-10 inline-flex items-center gap-x-2 text-white bg-slate-500  hover:bg-slate-500/80 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                                    <BsCheck2Circle className='text-lg' />KAYDET
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
        </>
    );
}

export default SistemAyarlari;
